import { styled } from '@mui/system';

export const StyledStrongLink = styled('strong')(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
  cursor: 'pointer',
}));
